/**
 * 日期工具函数
 */
import dayjs from './dayjs';
import type { Dayjs } from 'dayjs'; // 直接从库里引入类型，或者改为 import { Dayjs } from 'dayjs';

export type TimeGranularity = 'day' | 'week' | 'month' | 'quarter' | 'year';

/**
 * 获取默认日期范围
 */
export function getDefaultDateRange(granularity: TimeGranularity = 'day'): [Dayjs, Dayjs] {
  const end = dayjs();
  let start: Dayjs;

  switch (granularity) {
    case 'day':
      start = end.subtract(30, 'day');
      break;
    case 'week':
      start = end.subtract(12, 'week');
      break;
    case 'month':
      start = end.subtract(12, 'month');
      break;
    case 'quarter':
      start = end.subtract(8, 'quarter');
      break;
    case 'year':
      start = end.subtract(5, 'year');
      break;
    default:
      start = end.subtract(30, 'day');
  }

  return [start, end];
}

/**
 * 格式化日期用于显示
 */
export function formatDateForDisplay(date: string | Dayjs, granularity: TimeGranularity = 'day'): string {
  const d = dayjs(date);

  switch (granularity) {
    case 'day':
      return d.format('YYYY-MM-DD');
    case 'week':
      return `${d.format('YYYY')}年第${d.week()}周`;
    case 'month':
      return d.format('YYYY-MM');
    case 'quarter':
      return `${d.format('YYYY')}年Q${d.quarter()}`;
    case 'year':
      return d.format('YYYY');
    default:
      return d.format('YYYY-MM-DD');
  }
}

/**
 * 格式化日期用于API请求
 */
export function formatDateForApi(date: Dayjs): string {
  return date.format('YYYY-MM-DDTHH:mm:ss');
}
